import {
  CREATE_CUSTOMER,
  GET_CUSTOMERS,
  GET_DETAIL,
  SET_LOADING,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_AVATAR,
  UPDATE_CUSTOMER_USERNAME,
} from '../types/customer';

export function getCustomers(params) {
  return { type: GET_CUSTOMERS, params };
}

export function getCustomerDetail(params) {
  return { type: GET_DETAIL, params };
}

export function createCustomer(params, callback) {
  return { type: CREATE_CUSTOMER, params, callback };
}

export function updateCustomer(params, callback) {
  return { type: UPDATE_CUSTOMER, params, callback };
}

export function updateCustomerAvatar(params) {
  return { type: UPDATE_CUSTOMER_AVATAR, params };
}

export function setLoading(isLoading = false) {
  return { type: SET_LOADING, isLoading };
}

export function updateCustomerUsername(params, callback) {
  return { type: UPDATE_CUSTOMER_USERNAME, params, callback };
}
